import { createErrorClass } from './createErrorClass';
export const NotFoundError = createErrorClass(_super => function NotFoundErrorImpl(message) {
  _super(this);
  this.name = 'NotFoundError';
  this.message = message;
});
